// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9764d2ee","455":"1e387f2c","977":"c730f3bf"}[chunkId] + ".chunk.js";
};